import { API_PATH } from 'config';
import { apiAssetUrl } from 'utils/apiAssetUrl';

// Resuelve un valor de logo (campo `template.logo` o `section.config.logo`) a
// una URL que `<Image src>` de @react-pdf/renderer pueda fetchear.
//
// Reglas:
//   - null/undefined/"" → null (no se renderiza el logo).
//   - http(s)://... → URL absoluta, se usa tal cual.
//   - Path que empieza con "/" → se resuelve contra el origen del API vía
//     `apiAssetUrl`. Ej. "/api/v1/tenants/1/logo-file", que devuelve el backend
//     vía resolveLogoUrlForClient. NO se re-prefija con API_PATH completo
//     (daría "/api/v1/api/v1/..." duplicando): solo se le antepone el origin.
//     Devolverlo relativo hacía que @react-pdf lo resolviera contra
//     window.location — el dominio del front, donde el API no vive en
//     producción — y el logo salía vacío en el PDF.
//   - Cualquier otro string (ej. "logo.png", "assets/x.png") → se prefija con
//     API_PATH asumiendo que es relativo al API.
export function resolveLogoUrl(raw) {
  if (!raw) return null;
  if (/^https?:\/\//.test(raw)) return raw;
  if (raw.startsWith('/')) return apiAssetUrl(raw);
  return `${API_PATH}/${raw}`;
}
